import { render, staticRenderFns } from "./UserActionsMenu.vue?vue&type=template&id=2c27ea2f&scoped=true"
import script from "./UserActionsMenu.vue?vue&type=script&lang=js"
export * from "./UserActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./UserActionsMenu.vue?vue&type=style&index=0&id=2c27ea2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27ea2f",
  null
  
)

export default component.exports